import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_SETTING_LISTING,
    GET_SETTING_DETAILS,
    ADD_SETTING,
    UPDATE_SETTING,
    DELETE_SETTING,
    EXPORT_SETTING,
    GET_POINT_LISTING,
    UPDATE_POINT,
} from "./actionTypes.js";

import {
    getSettingListingSuccess,
    getSettingListingFail,
    createSettingSuccess,
    createSettingFail,
    updateSettingSuccess,
    updateSettingFail,
    deleteSettingSuccess,
    deleteSettingFail,
    exportSettingSuccess,
    exportSettingFail,
    getSettingDetailsSuccess,
    getSettingDetailsFail,
    getPointListingSuccess,
    getPointListingFail,
    updatePointSuccess,
    updatePointFail,
} from "./actions.js";

import {
    settingListingApi,
    updateSettingApi,
    deleteSettingApi,
    exportSettingApi,
    settingDetailsApi,
    addSettingApi,
} from "./settingApi.js";
import { pointListingApi } from "./settingApi.js";
import { updatePointApi } from "./settingApi.js";

function* fetchSettingListing({ payload }) {
    try {
        const response = yield call(settingListingApi, payload);
        yield put(getSettingListingSuccess(response));
    } catch (error) {
        yield put(getSettingListingFail(error));
    }
}

function* updateSetting({ payload }) {
    try {
        const response = yield call(updateSettingApi, payload);
        yield put(updateSettingSuccess(response));
    } catch (error) {
        yield put(updateSettingFail(error));
    }
}

function* fetchPointListing({ payload }) {
    try {
        const response = yield call(pointListingApi, payload);
        yield put(getPointListingSuccess(response));
    } catch (error) {
        yield put(getPointListingFail(error));
    }
}

function* updatePoint({ payload }) {
    try {
        const response = yield call(updatePointApi, payload);
        yield put(updatePointSuccess(response));
    } catch (error) {
        yield put(updatePointFail(error));
    }
}

function* SettingSaga() {
    yield takeEvery(GET_SETTING_LISTING, fetchSettingListing);
    yield takeEvery(UPDATE_SETTING, updateSetting);
    yield takeEvery(GET_POINT_LISTING, fetchPointListing);
    yield takeEvery(UPDATE_POINT, updatePoint);

}

export default SettingSaga
